export const downloadBackupCodes = (codes: string[]) => {
    const blob = new Blob(
        [`Office Management — Two-Factor Backup Codes\n\n${codes.join('\n')}\n`],
        { type: 'text/plain' }
    );
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'backup-codes.txt';
    link.click();
    URL.revokeObjectURL(url);
};

export const copyBackupCodes = (codes: string[]): Promise<void> => {
    return navigator.clipboard.writeText(codes.join('\n'));
};

export interface BackupCodesPrintLabels {
    title: string;
    note: string;
}

const ENGLISH_PRINT_LABELS: BackupCodesPrintLabels = {
    title: 'Two-Factor Backup Codes',
    note: 'Each code can be used once. Store this somewhere safe.',
};

/** Prints the codes. Pass `labels` for a translated heading and note; English otherwise. */
export const printBackupCodes = (codes: string[], labels: BackupCodesPrintLabels = ENGLISH_PRINT_LABELS) => {
    const printWindow = window.open('', '_blank');
    if (!printWindow) return;
    printWindow.document.write(`
        <html>
            <head><meta charset="utf-8"><title>${labels.title}</title></head>
            <body style="font-family: monospace; padding: 24px;">
                <h2 style="font-family: sans-serif;">${labels.title}</h2>
                <p style="font-family: sans-serif;">${labels.note}</p>
                <pre style="font-size: 16px; line-height: 1.6;">${codes.join('\n')}</pre>
            </body>
        </html>
    `);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
};
